import React from "react";
import VariableForm from "./VariableForm";

/** Thin mode wrapper around the shared VariableForm (SCRUM-899). */
const AddVariable = () => <VariableForm mode="add" />;

export default AddVariable;
